import getList from './getList';
import add from './add';
import edit from './edit';
import del from './del';
export default {
  getList,
  add,
  edit,
  del
};


// WEBPACK FOOTER //
// ./src/api/netelementcustom/index.ts